module.exports = __webpack_public_path__ + "img/logo.6f05a9ac.png";